module.exports = {"Operate23":{"daobanList":[{"title":"1、是否办理特殊建设工程消防验收","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"特殊建设工程消防验收申请表","state":"必要"},{"name":"工程竣工验收报告","state":"必要"},{"name":"涉及消防的建设工程竣工图纸","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]},{"name":"首次不合格第二次申请时需提交","xuanzhong":1,"cailiaoList":[{"name":"消防验收不合格意见书及整改情况（如存在需提供）","state":"必要"}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdo-23.json
// module id = 1281
// module chunks = 0